(function(){
var tocSticky=document.getElementById("mpTocSticky");
var desktopAnchor=document.getElementById("mpDesktopAnchor");
var content=document.getElementById("mpContent");
if(!desktopAnchor||!content)return;

var stickyDesktopBp=1800,tabletBp=768,headerOffset=110,desktopLeftOffset=290,lastScrollY=window.pageYOffset,stickyCoverHeight=70,firstSectionExtraOffset=0;

var articleTitle=document.querySelector('.article-template__title,.main-blog-title,h1');
var sections=[].slice.call(document.querySelectorAll(".mp-section"));
var allLinks=[].slice.call(document.querySelectorAll('a[href^="#s"]'));
var mobileTrigger=document.getElementById("mpTocMobileTrigger");
var mobileOverlay=document.getElementById("mpTocMobileOverlay");
var mobileClose=document.getElementById("mpTocMobileClose");

function isStickyDesktop(){return window.innerWidth>=stickyDesktopBp;}
function isMidToc(){return window.innerWidth>=tabletBp&&window.innerWidth<stickyDesktopBp;}
function isMobile(){return window.innerWidth<tabletBp;}
function getAbsTop(el){return el.getBoundingClientRect().top+window.pageYOffset;}
function getAbsLeft(el){return el.getBoundingClientRect().left+window.pageXOffset;}

function updateActive(){
if(!sections.length)return;
var currentId=sections[0].id;
var checkY=window.pageYOffset+headerOffset+stickyCoverHeight+20;
var nearBottom=window.innerHeight+window.pageYOffset>=document.documentElement.scrollHeight-40;
if(nearBottom){currentId=sections[sections.length-1].id;}
else{sections.forEach(function(section){if(getAbsTop(section)<=checkY)currentId=section.id;});}
allLinks.forEach(function(link){link.classList.toggle("is-active",link.getAttribute("href")==="#"+currentId);});
sections.forEach(function(section){var title=section.querySelector("h2");if(title){title.style.color="";title.style.transition="color .2s ease";}});
var activeSection=document.getElementById(currentId);
if(activeSection){var activeTitle=activeSection.querySelector("h2");if(activeTitle)activeTitle.style.color="#1e73e8";}
}

var observer=new MutationObserver(function(){
var el=document.querySelector('[style*="bottom: 46px"]');
if(!el)return;
if(window.innerWidth<768){
el.style.setProperty('bottom','3px','important');
el.style.setProperty('left','0px','important');
}
});
observer.observe(document.body,{childList:true,subtree:true});

function updateSticky(){
if(!tocSticky||!desktopAnchor||!content)return;

if(!isStickyDesktop()){
tocSticky.classList.remove("is-visible","is-fixed","is-bottom");
tocSticky.style.left="";
tocSticky.style.width="";
tocSticky.style.opacity="";
tocSticky.style.pointerEvents="";
tocSticky.style.transform="";
lastScrollY=window.pageYOffset;
return;
}

var scrollY=window.pageYOffset;
var delta=scrollY-lastScrollY;
var scrollingUp=delta<0;
var scrollingDown=delta>0;

var titleEl=articleTitle||content.querySelector("h1,h2");
var topTrigger=titleEl?getAbsTop(titleEl)-headerOffset-10:getAbsTop(content)-headerOffset;
var stickyHeight=tocSticky.offsetHeight;
var contentBottom=getAbsTop(content)+content.offsetHeight;
var stopFixedAt=contentBottom-stickyHeight-24;
var anchorLeft=getAbsLeft(desktopAnchor);
var fixedLeft=anchorLeft-desktopLeftOffset;

if(scrollY<topTrigger){
tocSticky.classList.remove("is-visible","is-fixed","is-bottom");
tocSticky.style.left="";
tocSticky.style.width="";
tocSticky.style.opacity="";
tocSticky.style.pointerEvents="";
tocSticky.style.transform="";
lastScrollY=scrollY;
return;
}

tocSticky.style.width="236px";

if(scrollY+headerOffset>=stopFixedAt){
tocSticky.classList.remove("is-fixed");
tocSticky.classList.add("is-bottom");
tocSticky.style.left="-290px";
}else{
tocSticky.classList.remove("is-bottom");
tocSticky.classList.add("is-fixed");
tocSticky.style.left=fixedLeft+"px";
}

var shouldHide=scrollingUp&&scrollY>topTrigger+20;
var shouldShow=scrollingDown||Math.abs(delta)<2;

if(shouldHide){
tocSticky.classList.remove("is-visible");
tocSticky.style.opacity="0";
tocSticky.style.pointerEvents="none";
tocSticky.style.transform="translateY(-8px)";
}else if(shouldShow){
tocSticky.classList.add("is-visible");
tocSticky.style.opacity="";
tocSticky.style.pointerEvents="";
tocSticky.style.transform="";
}

lastScrollY=scrollY;
}

function getJumpOffset(){return headerOffset+stickyCoverHeight+firstSectionExtraOffset;}

function openMobile(){
if(!mobileOverlay)return;
mobileOverlay.classList.add("is-open");
mobileOverlay.setAttribute("aria-hidden","false");
if(mobileTrigger)mobileTrigger.setAttribute("aria-expanded","true");
if(isMobile()){
document.documentElement.style.overflow="hidden";
document.body.style.overflow="hidden";
}
}

function closeMobile(){
if(!mobileOverlay)return;
mobileOverlay.classList.remove("is-open");
mobileOverlay.setAttribute("aria-hidden","true");
if(mobileTrigger)mobileTrigger.setAttribute("aria-expanded","false");
document.documentElement.style.overflow="";
document.body.style.overflow="";
}

function smoothJump(hash){
var target=document.querySelector(hash);
if(!target)return;
window.scrollTo({top:getAbsTop(target)-getJumpOffset(),behavior:"smooth"});
}

allLinks.forEach(function(link){
link.addEventListener("click",function(e){
var hash=this.getAttribute("href");
if(!hash||hash.charAt(0)!=="#")return;
e.preventDefault();

if(isStickyDesktop()){
tocSticky.classList.remove("is-visible");
tocSticky.style.opacity="0";
tocSticky.style.pointerEvents="none";
tocSticky.style.transform="translateY(-8px)";
smoothJump(hash);
return;
}

closeMobile();
setTimeout(function(){smoothJump(hash);},120);
});
});

if(mobileTrigger)mobileTrigger.addEventListener("click",openMobile);
if(mobileClose)mobileClose.addEventListener("click",closeMobile);
if(mobileOverlay){
mobileOverlay.addEventListener("click",function(e){
if(isMobile()&&e.target===mobileOverlay)closeMobile();
});
}

document.addEventListener("keydown",function(e){if(e.key==="Escape")closeMobile();});

function onUpdate(){updateActive();updateSticky();}

window.addEventListener("scroll",onUpdate,{passive:true});
window.addEventListener("resize",function(){
closeMobile();
lastScrollY=window.pageYOffset;
articleTitle=document.querySelector('.article-template__title,.main-blog-title,h1');
onUpdate();
});
window.addEventListener("load",function(){
lastScrollY=window.pageYOffset;
articleTitle=document.querySelector('.article-template__title,.main-blog-title,h1');
onUpdate();
});
document.body.classList.add("mp-toc-ready");
onUpdate();
})();